<template>
  <div class="tab_detail">
    <div class="list_details">
      <h1 class="title">{{detailData.detailedListTitle}}</h1>
      <ul class="room">
        <li :class="{item:true,single:(i+1)%2===1 && i+1 === detailData.detailedList.length}" v-for="(v,i) in detailData.detailedList" :key="i">
          <div class="label com_hidden">{{v.name}}</div>
          <div class="value">{{v.introduce}}</div>
        </li>
      </ul>
      <ul class="space">
        <li class="type" v-for="(item,index) in detailData.detailedList" :key="index">
          <h2 class="type_title">{{item.name}}</h2>
          <div class="line"></div>
          <ul class="type_content">
            <li class="item" v-for="(v,i) in item.mixList" :key="i">
              <router-link class="img_box mask" :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank">
                <img v-lazy="v.mainPreviewImageFilePath" alt="">
              </router-link>
              <div class="itr">
                <p class="com_hidden">
                  <router-link :to="{path:'/goodsDetails/'+v.serNo+'.html'}" target="_blank">{{v.mixName}}</router-link>
                </p>
                <p class="com_hidden">材质：{{v.materialName}}</p>
                <p class="com_hidden" v-if="v.mixGoodsLength && v.mixGoodsWidth && v.mixGoodsHeight">
                  尺寸：{{v.mixGoodsLength+"mm*"+v.mixGoodsWidth+"mm*"+v.mixGoodsHeight+"mm"}}
                </p>
              </div>
            </li>

          </ul>
        </li>
      </ul>
    </div>
    <div class="space_match" v-for="(v,i) in detailData.detailedList" :key="i">
      <div class="match_bc">
        <p class="p1">{{v.name+"搭配"}}</p>
        <p class="p2">S O F T L O A D I N G</p>
        <p class="p3"></p>
      </div>
      <div class="match_content" v-html="v.content"></div>
    </div>
  </div>
</template>

<script>
import { GetGoodsDetailThemeDetailByNo } from "@/pages/page1/api/modules/home";
export default {
  data() {
    return {
      img1: require("@/assets/img/whole_goods1.jpg"),
      detailData: {},
    };
  },
  mounted() {
    this.getGoodsDetailThemeDetailByNo(this.$route.query.themeNo);
  },
  methods: {
    getGoodsDetailThemeDetailByNo(themeNo) {
      GetGoodsDetailThemeDetailByNo({ themeNo }).then((res) => {
        // console.log("获取主题详情", res);
        let data = res.data[0];
        this.detailData = data;
        let obj = {
          themeInfo: {
            name: data.name,
            introduce: data.introduce,
          },
          previewImgList: data.previewImgList,
        };
        this.$emit("getThemeInfo", obj);
        this.detailData.detailedList.forEach((item) => {
          item.mixList.forEach((v) => {
            v.materialName = v.materialName.replace(/###/g, "+");
          });
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.tab_detail {
  padding-top: 48px;
  .list_details {
    background: #f4f4f4;
    padding: 0 78px 48px;
    .title {
      padding-top: 58px;
      font-size: 48px;
      font-weight: bold;
      text-align: center;
    }
    .room {
      margin-top: 76px;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: calc((100% - 2px) / 2);
        height: 70px;
        overflow: hidden;
        box-sizing: border-box;
        border: 1px solid #bfbfbf;
        margin-right: 2px;
        &:nth-child(2n) {
          margin-right: 0;
        }
        display: flex;
        align-items: center;
        .label {
          width: 140px;
          height: 66px;
          line-height: 66px;
          background: #bfbfbf;
          text-align: center;
          font-size: 26px;
        }
        .value {
          width: calc(100% - 140px);
          box-sizing: border-box;
          padding-left: 28px;
          height: 100%;
          font-size: 18px;
          line-height: 22px;
          height: auto;
          word-break: break-all;
        }
      }
      .single {
        width: 100%;
        margin-right: 0;
      }
    }
    .space {
      .type {
        box-sizing: border-box;
        padding: 32px 28px 40px 40px;
        background: #ffffff;
        margin-top: 12px;
        .type_title {
          font-size: 30px;
          font-weight: bold;
        }
        .line {
          margin-top: 36px;
          border: 1px dashed @themeColor;
          position: relative;
          &::before {
            width: 22px;
            height: 22px;
            background: @themeColor;
            display: block;
            content: "";
            position: absolute;
            left: -14px;
            top: 50%;
            margin-top: -11px;
            transform: rotate(45deg);
            -ms-transform: rotate(45deg); /* IE 9 */
            -moz-transform: rotate(45deg); /* Firefox */
            -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
            -o-transform: rotate(45deg); /* Opera */
          }
        }
        .type_content {
          margin-top: 22px;
          display: flex;
          flex-wrap: wrap;
          .item {
            height: 278px;
            // width: calc((100% - 100px) / 3);//在ie容易造成位置错乱
            width: 288px;
            box-sizing: border-box;
            padding: 0 8px;
            margin-right: 50px;
            &:nth-child(3n) {
              margin-right: 0;
            }
            .img_box {
              height: 191px;
              border-bottom: 1px solid #bfbfbf;
              padding: 10px 0;
              box-sizing: border-box;
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;
              margin-bottom: 10px;
              img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              }
            }
            .itr {
              line-height: 24px;
              p {
                height: 24px;
                a {
                  color: #000000;
                }
              }
            }
          }
        }
      }
    }
  }
  .space_match {
    .match_bc {
      background: url("~@/assets/img/whole_detail_banner.jpg") no-repeat;
      background-size: cover;
      height: 258px;
      box-sizing: border-box;
      padding-left: 120px;
      padding-top: 66px;
      color: #ffffff;
      .p1 {
        font-size: 30px;
        font-weight: bold;
        position: relative;
        display: inline-block;
        &::after {
          display: block;
          content: "";
          width: 210px;
          border: 1px dashed #ffffff;
          position: absolute;
          top: 50%;
          left: 110%;
          opacity: 0.8;
        }
      }
      .p2 {
        margin-top: 22px;
        font-size: 26px;
      }
      .p3 {
        margin-top: 40px;
        width: 60px;
        height: 10px;
        background: #ffffff;
      }
    }
    .match_content {
      box-sizing: border-box;
      /deep/ img {
        width: auto;
        height: auto;
        max-width: 100%;
      }
    }
  }
  .mask {
    position: relative;
    cursor: pointer;
    &::after {
      display: block;
      content: "";
      width: 100%;
      height: 100%;
      background: #000000;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      display: none;
    }
    &:hover {
      &::after {
        display: block;
      }
    }
  }
}
</style>